import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import MermaidBlock from "../documentation/components/MermaidBlock";
import { buildFlowModuleTreeChart } from "./buildFlowModuleTreeChart";

const FlowModuleConfigTreePanel = ({
  editorUserId,
  onEditorUserIdChange,
  editorUsers = [],
  formatFlowUserLabel,
  editorConfigs = [],
  validatorConfigs = [],
  managerConfigs = [],
  validatorUsers = [],
  managerUsers = [],
  preUsers = [],
  catalogModules = []
}) => {
  const { t } = useTranslation();

  const { chart, notes } = useMemo(
    () => buildFlowModuleTreeChart({
      editorUserId,
      editorConfigs,
      validatorConfigs,
      managerConfigs,
      editorUsers,
      validatorUsers,
      managerUsers,
      preUsers,
      catalogModules,
      labels: {
        catchAll: t("admin.flowModule.treeCatchAll"),
        noRecord: t("admin.flowModule.treeNoRecord"),
        preTitle: t("admin.flowModule.treePreTitle"),
        noConfig: t("admin.flowModule.treeNoConfig"),
        noPre: t("admin.flowModule.treeNoPre")
      }
    }),
    [
      editorUserId,
      editorConfigs,
      validatorConfigs,
      managerConfigs,
      editorUsers,
      validatorUsers,
      managerUsers,
      preUsers,
      catalogModules,
      t
    ]
  );

  return (
    <div>
      <p className="text-muted small">{t("admin.flowModule.treeHint")}</p>
      <div className="row g-2 mb-3">
        <div className="col-md-4">
          <label className="form-label">{t("admin.flowModule.selectEditor")}</label>
          <select
            className="form-select"
            value={editorUserId}
            onChange={(e) => onEditorUserIdChange(e.target.value)}
          >
            <option value="">{t("admin.flowModule.selectEditor")}</option>
            {editorUsers.map((user) => (
              <option key={user.id} value={user.id}>{formatFlowUserLabel(user)}</option>
            ))}
          </select>
        </div>
      </div>

      {!editorUserId && (
        <div className="alert alert-secondary small mb-0">{t("admin.flowModule.treeEmpty")}</div>
      )}

      {editorUserId && notes.map((note) => (
        <div key={note} className="alert alert-warning small">{note}</div>
      ))}

      {editorUserId && chart && (
        <MermaidBlock chart={chart} id={`flow-module-tree-${editorUserId}`} />
      )}
    </div>
  );
};

export default FlowModuleConfigTreePanel;
